import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { CANCEL_APPOINTMENT_BY_TOKEN } from '../../queries/cancel-appointment-by-token.js';
import { fromCancelAppointmentQueryToAppointment } from './adapters/fromCancelAppointmentQueryToAppointment.js';

function isAppointment(result) {
    return result.__typename === 'Appointment';
}
const useCancelAppointmentByToken = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useMutation(CANCEL_APPOINTMENT_BY_TOKEN, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            },
            timeout: 30000
        },
        onError: (error)=>{
            console.error(`Error occurred while executing CANCEL_APPOINTMENT_BY_TOKEN query: `, error);
        }
    });
    const data = React.useMemo(()=>{
        var ref, ref1;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.cancelAppointmentByToken) && isAppointment((ref1 = queryState.data) === null || ref1 === void 0 ? void 0 : ref1.cancelAppointmentByToken) ? fromCancelAppointmentQueryToAppointment(queryState.data.cancelAppointmentByToken) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useCancelAppointmentByToken as default };
//# sourceMappingURL=use-cancel-appointment-by-token.js.map
